/**
 * SIATA Santa Elena local radar — source inventory (approved for development, not live).
 * See docs/weather/siata-santa-elena-radar-approval.md
 */

export const SIATA_SANTA_ELENA_RADAR_KEY = "siata_santa_elena_radar";

export const SIATA_SANTA_ELENA_RADAR_ATTRIBUTION_PLACEHOLDER =
  "Radar imagery: SIATA / Área Metropolitana del Valle de Aburrá.";

export const SIATA_SANTA_ELENA_RADAR_INVENTORY = {
  sourceKey: SIATA_SANTA_ELENA_RADAR_KEY,
  registrySourceCode: "SIATA_SANTA_ELENA",
  displayName: "SIATA Santa Elena Radar",
  agency: "SIATA / Área Metropolitana del Valle de Aburrá (AMVA)",
  operator: "SIATA",
  sourceType: "radar_static_imagery",
  trustLevel: "local_official",
  trustLabel: "Local official",
  coverageArea: "Aburrá Valley / AMVA",
  accessStatus: "approved_development",
  integrationStatus: "provider_configured",
  publicAccessStatus: "approved_development",
  providerStatus: "not_implemented",
  expectedUpdateCadence: "5–10 min target (confirm exact SIATA polling limit)",
  expectedFormat:
    "Static imagery — JPEG (ProdDBZ_AMVA_Radar_10_120.jpeg), GeoTIFF (AreaMetRadar_10_120_DBZH.tiff), PNG archive (data/radar/)",
  pipelineType: "bart_like_static_image",
  contactStatus: "approved",
  enabled: false,
  requiresPartnership: false,
  featureFlagEnv: "SIATA_SANTA_ELENA_RADAR_ENABLED",
  clientFeatureFlagEnv: "REACT_APP_SIATA_SANTA_ELENA_RADAR_ENABLED",
  configModule: "server/weather/config/siataSantaElenaRadarConfig.js",
  providerModule: "server/weather/providers/siataRadarProvider.js",
  attribution: SIATA_SANTA_ELENA_RADAR_ATTRIBUTION_PLACEHOLDER,
  notes:
    "Milestone 2 complete: provider configured and feature-flagged. Frame discovery/cache not implemented. Public UI remains off unless REACT_APP_SIATA_SANTA_ELENA_RADAR_ENABLED=true.",
  planDocPath: "docs/weather/siata-santa-elena-radar-plan.md",
  approvalDocPath: "docs/weather/siata-santa-elena-radar-approval.md",
  integrationPlanDocPath: "docs/weather/siata-santa-elena-radar-integration-plan.md",
};

export const SIATA_SANTA_ELENA_OUTREACH_DRAFT_EN = `Subject: Data access inquiry — SIATA Santa Elena radar for civic weather awareness (Midpoint Map)

Dear SIATA / AMVA team,

We are building Midpoint Map, a community intelligence platform that helps residents understand weather conditions in Medellín and the Aburrá Valley. We already integrate SIATA Geoportal sensor layers (rain gauges, quebrada levels, environmental alerts) with proper attribution.

We would like to explore whether radar imagery or metadata from the Santa Elena radar site is available for public or partner access, to display as a clearly labeled "local official" radar layer alongside national IDEAM composite radar.

Could you please advise:

1. Whether SIATA Santa Elena radar data is available via API, WMS/WMTS, image tiles, or another documented endpoint
2. Available formats (PNG/GIF composites, raster tiles, GeoTIFF, JSON metadata, etc.)
3. Update cadence, latency, and geographic coverage footprint
4. Projection/georeferencing details and timestamp conventions (local vs UTC)
5. Attribution requirements and terms of use for public display
6. Whether authentication or a formal data agreement is required
7. A technical contact for integration documentation

We will respect all access controls and attribution requirements. We do not intend to scrape protected endpoints or bypass authentication.

Thank you for your time.

Best regards,
[Your name]
[Organization]
[Contact email]`;

export const SIATA_SANTA_ELENA_OUTREACH_DRAFT_ES = `Asunto: Consulta de acceso a datos — radar SIATA Santa Elena para información meteorológica cívica (Midpoint Map)

Estimado equipo de SIATA / AMVA:

Estamos desarrollando Midpoint Map, una plataforma de inteligencia comunitaria que ayuda a las personas a comprender las condiciones del tiempo en Medellín y el Valle de Aburrá. Ya integramos capas del Geoportal SIATA (pluviómetros, niveles en quebradas, alertas ambientales) con la atribución correspondiente.

Nos gustaría explorar si las imágenes o metadatos del radar de Santa Elena están disponibles para acceso público o mediante convenio, para mostrarlos como una capa claramente identificada como radar "oficial local", complementando el radar compuesto nacional de IDEAM.

¿Podrían indicarnos, por favor?

1. Si los datos del radar SIATA Santa Elena están disponibles vía API, WMS/WMTS, teselas de imagen u otro endpoint documentado
2. Formatos disponibles (composites PNG/GIF, teselas raster, GeoTIFF, metadatos JSON, etc.)
3. Cadencia de actualización, latencia y cobertura geográfica
4. Detalles de proyección/georreferenciación y convención de marcas de tiempo (hora local vs UTC)
5. Requisitos de atribución y condiciones de uso para visualización pública
6. Si se requiere autenticación o un acuerdo formal de datos
7. Un contacto técnico para documentación de integración

Respetaremos todos los controles de acceso y requisitos de atribución. No tenemos intención de extraer datos de endpoints protegidos ni eludir autenticación.

Muchas gracias por su tiempo.

Atentamente,
[Su nombre]
[Organización]
[Correo de contacto]`;

export function buildSiataSantaElenaContactPayload() {
  return {
    subject: "SIATA Santa Elena radar data access inquiry",
    english: SIATA_SANTA_ELENA_OUTREACH_DRAFT_EN,
    spanish: SIATA_SANTA_ELENA_OUTREACH_DRAFT_ES,
    inventory: SIATA_SANTA_ELENA_RADAR_INVENTORY,
    planDoc: SIATA_SANTA_ELENA_RADAR_INVENTORY.planDocPath,
    approvalDoc: SIATA_SANTA_ELENA_RADAR_INVENTORY.approvalDocPath,
  };
}
